<template>
  <div class="login-background">
    <!-- 语言选择器 -->
    <!-- <div class="language-selector">
      <el-radio-group
        v-model="languages"
        fill="#3fb393"
        @change="changeLanguages"
        size="small"
      >
        <el-radio-button label="1"><span>中文</span></el-radio-button>
        <el-radio-button label="2"><span>日本語</span></el-radio-button>
        <el-radio-button label="3"><span>ENG</span></el-radio-button>
      </el-radio-group>
    </div> -->

    <!-- 主内容区 -->
    <div class="content-container">
      <div class="dialogBoxMes card">
        <!-- 标题区域 -->
        <div class="title-bar">
          <h2 class="main-title">{{ $t("label_749") }}</h2>
          <div class="subtitle-info">
            <p>
              {{ tableDataTree.superior }}<br />
              {{ tableDataTree.etname }} {{ tableDataTree.ename }}
              {{ tableDataTree.code }}
            </p>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-container">
          <el-table
            :empty-text="$t('label_357')"
            ref="singleTable"
            :data="tableDataTree.list"
            highlight-current-row
            @current-change="handleCurrentChangeTree"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;"
            height="600px"
            :header-cell-style="{
              'background-color': '#45494f',
              color: '#ffffff',
              'font-weight': '500'
            }"
            :cell-style="{
              transition: 'background-color 0.2s'
            }"
          >
            <!-- 表格列定义保持不变 -->
            <el-table-column
              header-align="center"
              align="center"
              :label="$t('label_369') + '.'"
              type="index"
              width="58"
            ></el-table-column>

            <el-table-column
              prop="name"
              :label="$t('label_533')"
              align="center"
              width="520"
            >
              <template slot-scope="scope">
                {{ scope.row.name }}
                <br />
                <popMesBox
                  :popMes="scope.row.content"
                  :hoverMes="scope.row.content"
                  :popWidth="200"
                ></popMesBox>
              </template>
            </el-table-column>

            <el-table-column
              prop="cycleType"
              :label="$t('label_741')"
              align="center"
              width="260"
            >
              <template slot-scope="scope">
                <template v-if="scope.row.cycleType == '1'">{{
                  scope.row.cycle == "0"
                    ? $t("label_652")
                    : $t("label_531") + scope.row.cycle + $t("label_537")
                }}</template>
                <template v-if="scope.row.cycleType == '2'">{{
                  scope.row.cycle == 0
                    ? weekendMesOptions[6].label
                    : weekendMesOptions[scope.row.cycle - 1].label
                }}</template>
                <template v-if="scope.row.cycleType == '3'">{{
                  scope.row.cycle > 20
                    ? $t("label_238") + scope.row.cycle + $t("label_537")
                    : scope.row.cycle > 10
                    ? $t("label_242") + scope.row.cycle + $t("label_537")
                    : $t("label_245") + scope.row.cycle + $t("label_537")
                }}</template>
                <template v-if="scope.row.cycleType == '8'">{{
                  $t("label_531") + scope.row.cycle + $t("label_743")
                }}</template>
                <template v-if="scope.row.cycleType == '9'">{{
                  $t("label_531") + scope.row.cycle + $t("label_542")
                }}</template>
              </template>
            </el-table-column>

            <el-table-column
              prop="method"
              :label="$t('label_742')"
              align="center"
              width="400"
            >
              <template slot-scope="scope">
                {{ checkText(scope.row.method) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="photo"
              :label="$t('label_865')"
              align="center"
              width="500px"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.photo != null && scope.row.photo != ''">
                  <span
                    v-if="scope.row.photo != null && scope.row.photo != ''"
                    v-for="item in scope.row.photo.split(',')"
                    style="border: 1px solid #dedede;display: inline-block;padding: 8px 5px 0 5px"
                  >
                    <img
                      style="width: 30px;height: 30px;"
                      :src="
                        $store.getters.getPostUrl +
                          'mes/sysFile/download/' +
                          item
                      "
                      @click="show(item, 'photo')"
                    />
                  </span>
                </span>
                <span v-if="scope.row.video != null && scope.row.video != ''">
                  <span
                    v-if="scope.row.video != null && scope.row.video != ''"
                    v-for="item in scope.row.video.split(',')"
                    style="border: 1px solid #dedede;display: inline-block;padding: 8px 5px 0 5px"
                  >
                    <img
                      style="width: 30px;height: 30px;"
                      src="../../assets/img/spot/video.png"
                      @click="show(item, 'video')"
                    />
                  </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 图片查看弹窗 -->
        <el-dialog
          :visible.sync="dialogImg"
          width="60%"
          :before-close="closeImg"
          custom-class="image-preview-dialog"
        >
          <!-- <div slot="title">
            <span style="font-size: 16px; font-weight: bold;">{{
              $t("label_866") || "图片预览"
            }}</span>
          </div> -->
          <div class="image-preview-container" style="text-align: center;">
            <img
              :src="$store.getters.getPostUrl + 'mes/sysFile/download/' + img"
              style="max-width: 100%; max-height: 70vh;"
              alt="预览图片"
            />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeImg" type="primary">{{
              $t("label_100") || "关闭"
            }}</el-button>
          </span>
        </el-dialog>

        <!-- 视频查看弹窗 -->
        <el-dialog
          :visible.sync="dialogVideo"
          width="70%"
          :before-close="closeImg"
          custom-class="video-preview-dialog"
        >
          <!-- <div slot="title">
            <span style="font-size: 16px; font-weight: bold;">{{
              $t("label_867") || "视频预览"
            }}</span>
          </div> -->
          <div class="video-preview-container" style="text-align: center;">
            <video
              :src="$store.getters.getPostUrl + 'mes/sysFile/download/' + img"
              controls
              style="max-width: 100%; max-height: 70vh;"
            >
              {{ $t("label_868") || "您的浏览器不支持视频播放" }}
            </video>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeImg" type="primary">{{
              $t("label_100") || "关闭"
            }}</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

    <!-- 页脚信息 -->
    <!-- <footer class="page-footer">
      <div><a target="_blank" href="http://beian.miit.gov.cn/">此页面仅供邮件查看</a></div>
    </footer> -->
  </div>
</template>

<script>
import Request from "@/assets/js/request/request.js";
import utils from "@/utils/utils.js";
import global from "@/assets/js/common/common.js";
import { loadLanguageAsync } from "../../main";
import "@/assets/css/common/spot.css";
import popMesBox from "@/components/list/popover/pop";
import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
import file from "@/assets/js/file/file.js";

export default {
  name: "SpotCheckEmail",
  components: {
    popMesBox
  },
  data() {
    return {
      username: "",
      password: "",
      qrCodeShow: false,
      loading: false,
      width: "0",
      telephone: "",
      mail: "",
      address: "",
      cookie: "",
      languages: "2",

      // 从URL获取的ID
      tableIds: [], // 新：存储多个id的数组
      // 弹窗控制
      dialogSpotResult: true,
      dialogImg: false,
      dialogVideo: false,
      emailDialogVisible: false,

      // 数据存储
      tableDataTree: {},
      tableDataTreeInfo: [],
      img: "",
      checkList: [],
      selectedIds: [],
      selectedItems: []
    };
  },
  methods: {
    // 从URL获取参数
    getUrlParams(name) {
      const emailParams = [];
      // 1. 拿到URL中"?"后面的参数部分
      const queryString = window.location.search.substr(1);
      // 2. 分割所有参数（以"&"为分隔符）
      const paramPairs = queryString.split("&");

      // 3. 遍历每个参数，匹配目标name
      paramPairs.forEach(pair => {
        if (pair) {
          const [key, value] = pair.split("=");
          // 4. 若参数名匹配，解码后加入数组
          if (key === name) {
            emailParams.push(decodeURIComponent(value));
          }
        }
      });

      return emailParams; // 返回所有匹配的参数值数组
    },
    checkResults() {
      if (this.tableIds && this.tableIds.length > 0) {
        this.tableDataTree = {};
        SpotCheck.getCheckEmailById({
          ids: this.tableIds,
          positionCode: ""
        })
          .then(response => {
            const data = response.data;
            if (data.code == "1") {
              this.tableDataTree = data.data;
              if (
                this.tableDataTree.checkEndTime != null &&
                this.tableDataTree.checkBeginTime != null
              ) {
                let checkEndTime = new Date(
                  this.tableDataTree.checkEndTime
                ).getTime();
                let checkBeginTime = new Date(
                  this.tableDataTree.checkBeginTime
                ).getTime();
                let date = checkEndTime - checkBeginTime; //时间差的毫秒数
                // //计算相差分钟数
                // let leave2 = date % (3600 * 1000) //计算小时数后剩余的毫秒数
                // let minutes = Math.floor(leave2 / (60 * 1000))<10?'0'+Math.floor(leave2 / (60 * 1000)):Math.floor(leave2 / (60 * 1000))
                // //计算相差秒数
                // let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
                // let seconds = Math.round(leave3 / 1000)<10?'0'+Math.round(leave3 / 1000):Math.round(leave3 / 1000)
                // this.tableDataTreeInfo.time1= minutes;
                // this.tableDataTreeInfo.time2= seconds;
                let endTime = new Date(this.tableDataTree.endTime).getTime();
                let beginTime = new Date(
                  this.tableDataTree.beginTime
                ).getTime();

                //计划时间
                let date3 = endTime - beginTime;
                // //计算相差分钟数
                // let minutes2 = Math.floor(date3 / (60 * 1000))<10?'0'+Math.floor(date3 / (60 * 1000)):Math.floor(date3 / (60 * 1000))
                // //计算相差秒数
                // var leave5 = date3 % (60 * 1000) //计算分钟数后剩余的毫秒数
                // var seconds2 = Math.round(leave5 / 1000)<10?'0'+Math.round(leave5 / 1000):Math.round(leave5 / 1000)
                // this.tableDataTreeInfo.time3= minutes2;
                // this.tableDataTreeInfo.time4= seconds2;
                if (checkBeginTime > endTime) {
                  //实际点检时间 ok
                  this.styleObject4.width = "66%";
                  this.styleObject5.width = "0%";
                  //计划点检时间
                  this.styleObject6.width = "0%";
                  this.styleObject7.width = "66%";

                  this.styleObject1.width = "50%";
                  this.styleObject2.width = "50%";
                  this.styleObject3.width = "0%";
                } else if (
                  beginTime < checkBeginTime &&
                  checkEndTime > endTime
                ) {
                  var a = ((checkBeginTime - beginTime) / date3) * 0.8 * 100;
                  var b = (endTime - checkEndTime) / date3;
                  //实际点检时间
                  this.styleObject4.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject5.width = "0%";
                  //计划点检时间
                  this.styleObject6.width = "0%";
                  this.styleObject7.width = "20%";

                  this.styleObject1.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject2.width = 100 - (a < 0 ? 0 : a) + "%";
                  this.styleObject3.width = "0%";
                } else if (
                  beginTime > checkBeginTime &&
                  checkEndTime > endTime
                ) {
                  //实际点检时间
                  this.styleObject4.width = "0%";
                  this.styleObject5.width = "0%";
                  //计划点检时间
                  this.styleObject6.width = "20%";
                  this.styleObject7.width = "20%";

                  this.styleObject1.width = "0%";
                  this.styleObject2.width = "100%";
                  this.styleObject3.width = "0%";
                } else if (
                  beginTime > checkBeginTime &&
                  checkEndTime < endTime
                ) {
                  var b = ((endTime - checkEndTime) / date3) * 0.8 * 100;
                  //实际点检时间
                  this.styleObject4.width = "0%";
                  this.styleObject5.width = b + "%";
                  //计划点检时间
                  this.styleObject6.width = "20%";
                  this.styleObject7.width = "0%";

                  this.styleObject1.width = "0%";
                  this.styleObject2.width = 100 - b + "%";
                  this.styleObject3.width = b + "%";
                } else {
                  var a = ((checkBeginTime - beginTime) / date3) * 100;
                  var b = ((endTime - checkEndTime) / date3) * 100;
                  this.styleObject4.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject5.width = (b < 0 ? 0 : b) + "%";
                  //计划点检时间
                  this.styleObject6.width = "0%";
                  this.styleObject7.width = "0%";

                  this.styleObject1.width = (a < 0 ? 0 : a) + "%";
                  this.styleObject2.width =
                    100 - (a < 0 ? 0 : a) - (b < 0 ? 0 : b) + "%";
                  this.styleObject3.width = (b < 0 ? 0 : b) + "%";
                }
              } else {
                //实际点检时间
                this.styleObject4.paddingLeft = "0%";
                this.styleObject5.paddingRight = "0%";
                //计划点检时间
                this.styleObject6.paddingLeft = "0%";
                this.styleObject7.paddingRight = "0%";

                this.styleObject1.width = "100%";
                this.styleObject2.width = "0%";
                this.styleObject3.width = "0%";
              }
            }
          })
          .catch(response => {
            console.log(response);
          });
        this.errIds.splice(this.errIds.indexOf(this.tableDataTree.id), 1);
        this.dialogSpotResult = true;
      } else {
        this.$message({
          message: this.$t("msg_1"),
          type: "warning"
        });
      }
    },

    // 加载点检结果数据
    loadCheckResult() {
      if (!this.tableIds || this.tableIds.length === 0) return;

      SpotCheck.getCheckEmailById({
        ids: this.tableIds, // 同样传递id数组
        positionCode: ""
      })
        .then(response => {
          const data = response.data;
          if (data.code === "1") {
            this.tableDataTree = data.data;
            this.calculateTimeStyle();
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    changeLanguages() {
      this.$store.commit("setLanguageName", this.languages);
      let languageType;
      if (this.languages == "1") {
        languageType = "chs";
        // loadLanguageAsync('chs')
      } else if (this.languages == "2") {
        languageType = "ja";
        // loadLanguageAsync('ja')
      } else if (this.languages == "3") {
        languageType = "en";
        // loadLanguageAsync('en')
      }
      loadLanguageAsync(languageType);
      // sessionStorage.setItem("languageType", languageType);
    },
    showBtn() {
      this.qrCodeShow = !this.qrCodeShow;
      if (this.qrCodeShow) {
        this.width = "200";
      } else {
        this.width = "0";
      }
    },
    getColors() {
      Request.getColors()
        .then(response => {
          const data = response.data;
          if (data.code == "1") {
            let color = {};
            for (let i in data.data) {
              color[data.data[i].status] = data.data[i];
            }
            this.$store.commit("setColor", color);
          } else {
            utils.messageAlert(
              data.data.msg,
              this.$t("label_717"),
              this.$t("label_100")
            );
          }
        })
        .catch(response => {
          console.log(response);
        });
    },
    getCookie(cookie) {
      let arr = cookie.split("; "),
        obj = {};
      for (let i = 0; i < arr.length; i++) {
        let c = arr[i].split("=");
        let key = decodeURIComponent(c[0]),
          value = decodeURIComponent(c[1]);
        obj[key] = value;
      }
      return obj;
    },
    setCookie(cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires;
    },
    setLanguage() {
      Request.setLanguage(3)
        .then(response => {
          /*const data = response.data;
          console.log(data)*/
        })
        .catch(response => {
          console.log(response);
        });
    },
    // 处理选择变化事件
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id);
      this.selectedItems = selection;
    },

    show(id, type) {
      console.log("触发show方法：", "文件ID=", id, "类型=", type);
      this.img = id;

      // 确保在下一个tick更新，避免DOM更新延迟
      this.$nextTick(() => {
        if (type === "video") {
          this.dialogVideo = true;
          console.log("视频弹窗状态设置为：", this.dialogVideo);
        } else {
          this.dialogImg = true;
          console.log("图片弹窗状态设置为：", this.dialogImg);
        }
      });
    },

    // 关闭图片/视频弹窗
    closeImg() {
      this.dialogImg = false;
      this.dialogVideo = false;
    },

    // 处理关闭事件
    handleClose() {
      this.dialogSpotResult = false;
      // 可以添加返回上一页的逻辑
      // window.history.back();
    },

    // 处理当前行变化
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },

    // 检查文本
    checkText(type) {
      let typeText = type.toString();
      let data = this.checkList.filter(function(item) {
        return item.key == typeText;
      });
      if (data != "") {
        return data[0].val;
      }
    },
    getcheckList() {
      let languageType;
      if (this.languages === "1") {
        languageType = "chs";
        // loadLanguageAsync('chs') // 如需执行语言加载可取消注释
      } else if (this.languages === "2") {
        languageType = "ja";
        // loadLanguageAsync('ja')
      } else if (this.languages === "3") {
        languageType = "en";
        // loadLanguageAsync('en')
      }
      // 定义要传递的参数（根据实际需求修改值）
      const params = {
        dictId: 2, // 必传参数，例如这里传 2（替换掉原来 URL 里的硬编码）
        ...(languageType && { languageType }) // 可选参数，根据需要传递，不需要可以省略
      };
      file
        .getCheckEmailList(params)
        .then(response => {
          const data = response.data;
          if (data.code == "1") {
            this.checkList = data.data;
          }
        })
        .catch(response => {
          console.log(response);
        });
    }
  },

  // beforeCreate() {
  //   localStorage.setItem("LoginLanguage", "ja");
  //   if (Glod) {
  //     if (
  //       Glod.BaseUrl != "" &&
  //       Glod.BaseUrl != null &&
  //       Glod.BaseUrl != undefined
  //     ) {
  //       this.$store.commit("setPostUrl", Glod.BaseUrl);
  //     }
  //     if (Glod.Version > 0) {
  //       this.versions = Glod.Version;
  //       this.$store.commit("setVersions", Glod.Version);
  //     }
  //     if (
  //       Glod.AppDownloadURL != "" &&
  //       Glod.AppDownloadURL != null &&
  //       Glod.AppDownloadURL != undefined
  //     ) {
  //       this.$store.commit("setAppDownloadURL", Glod.AppDownloadURL);
  //     }
  //     if (Glod.DownloadAppFlag >= 0) {
  //       this.$store.commit("setDownloadAppFlag", Glod.DownloadAppFlag);
  //     }
  //     if (
  //       Glod.LogoClass != "" &&
  //       Glod.LogoClass != null &&
  //       Glod.LogoClass != undefined
  //     ) {
  //       this.$store.commit("setLogoClass", Glod.LogoClass);
  //     }
  //     if (
  //       Glod.ShowMap != undefined &&
  //       Glod.ShowMap != null &&
  //       Glod.ShowMap != ""
  //     ) {
  //       this.$store.commit("setShowMap", Glod.ShowMap);
  //     }
  //   }
  //   // 初始化
  //   const lang = store.getters.getLanguageName;
  //   if (lang == "1") {
  //     loadLanguageAsync("chs");
  //   }
  //   if (lang == "2") {
  //     loadLanguageAsync("ja");
  //   }
  //   if (lang == "3") {
  //     loadLanguageAsync("en");
  //   }
  // },
  mounted() {
    this.getColors();
    this.username = localStorage.getItem("LoginName");
    loadLanguageAsync("ja");
    this.loading = true;
    if (this.versions == 3) {
      this.cookie = this.getCookie(document.cookie);
      if (
        this.cookie.nameUser != null &&
        this.cookie.wordPass != null &&
        this.cookie.nameUser != "" &&
        this.cookie.wordPass != "" &&
        this.cookie.nameUser != undefined &&
        this.cookie.wordPass != undefined
      ) {
        this.username = this.cookie.nameUser;
        this.password = this.cookie.wordPass;
        this.login();
      } else {
        // window.open('about:blank', '_self').close()
      }
      setInterval(() => {
        let date1 = new Date(this.cookie.time);
        let date2 = new Date();
        let dateDiff = date2.getTime() - date1.getTime();
        if (dateDiff < 10000) {
          if (this.cookie != "") {
            let cookie = this.getCookie(document.cookie);
            this.cookie.time = cookie.time;
            if (
              cookie.nameUser != null &&
              cookie.wordPass != null &&
              cookie.nameUser != "" &&
              cookie.wordPass != "" &&
              cookie.nameUser != undefined &&
              cookie.wordPass != undefined
            ) {
              if (cookie.nameUser != this.cookie.nameUser) {
                this.loginOut();
                this.cookie = cookie;
                this.username = cookie.nameUser;
                this.password = cookie.wordPass;
                this.login();
              }
            } else {
              // window.open('about:blank', '_self').close()
            }
          } else {
            // window.open('about:blank', '_self').close()
          }
        } else {
          // this.setCookie('nameUser', "", -1);
          // this.setCookie('wordPass', "", -1);
          // window.open('about:blank', '_self').close()
        }
      }, 1000);
    }
    /* if (sessionStorage.getItem('store')) {
         this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
       }*/
    // this.username = "admin";
    // this.password = "admin";
    // this.login();
    this.$nextTick(() => {
      this.appQRCode();
    });
  },
  created() {
    this.getcheckList();

    // 修复：从URL获取ID并正确赋值给this.tableIds
    const urlParams = new URLSearchParams(window.location.search);
    const idParam = urlParams.get("id");
    if (idParam) {
      try {
        const binaryString = atob(idParam);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const decodedIds = new TextDecoder().decode(bytes);
        // 将逗号分隔的字符串转换为数组，并赋值给组件的tableIds
        this.tableIds = decodedIds.split(",").filter(id => id.trim() !== "");
        // console.log("ID数组:", this.tableIds);

        // 确保获取到ID后再调用接口
        if (this.tableIds.length > 0) {
          this.checkResults();
          this.loadCheckResult();
        } else {
          this.$message.error(this.$t("参数为空"));
          this.dialogSpotResult = false;
        }
      } catch (e) {
        console.error("Failed to decode IDs:", e);
        this.dialogSpotResult = false;
      }
    } else {
      this.$message.error(this.$t("缺少参数：id"));
      this.dialogSpotResult = false;
    }
  }
};
</script>

<style scoped>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 页面背景 */
.login-background {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
  position: relative;
}

/* 语言选择器 */
.language-selector {
  position: absolute;
  top: 0px;
  right: 20px;
  z-index: 10;
  background-color: #fff;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 内容容器 */
.content-container {
  margin: 0 auto;
  padding-top: 30px;
}

/* 卡片样式 */
.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  min-height: 500px; /* 增加最小高度 */
}

.card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

/* 标题区域 */
.title-bar {
  padding: 0px 30px;
  border-bottom: 1px solid #e8e8e8;
}

.main-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 500;
}

.subtitle-info {
  color: #666;
  line-height: 1.6;
  font-size: 14px;
}

/* 表格容器 */
.table-container {
  padding: 30px 40px; /* 增加内边距 */
  height: calc(100vh - 200px); /* 根据视口高度自适应 */
  min-height: 500px; /* 设置最小高度 */
}

/* 表格行交互效果 */
::v-deep .el-table__row {
  transition: background-color 0.2s;
}

::v-deep .el-table__row:hover {
  background-color: #f5f7fa !important;
}

::v-deep .el-table__current-row {
  background-color: #e6f7f0 !important;
}

/* 图片和视频预览样式优化 */
::v-deep .el-dialog__body {
  padding: 16px;
}

::v-deep .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
}

/* 页脚样式 */
.page-footer {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 12px;
  margin-top: 30px;
}

.page-footer a {
  color: #999;
  text-decoration: none;
  transition: color 0.2s;
}

.page-footer a:hover {
  color: #3fb393;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 1440px) {
  .content-container {
    padding: 60px 15px 0;
  }

  .title-bar,
  .table-container {
    padding: 15px 20px;
  }

  .el-table-column {
    width: auto !important;
  }
}

@media (max-width: 768px) {
  .language-selector {
    top: 10px;
    right: 10px;
  }

  .main-title {
    font-size: 18px;
  }

  .table-container {
    padding: 10px;
  }

  .el-table {
    height: 300px !important;
  }
}

/* 在style部分添加 */
::v-deep .image-preview-dialog .el-dialog__body,
::v-deep .video-preview-dialog .el-dialog__body {
  padding: 10px;
}

::v-deep .image-preview-dialog .el-dialog__header,
::v-deep .video-preview-dialog .el-dialog__header {
  border-bottom: 1px solid #e8e8e8;
  padding: 15px 20px;
}

.image-preview-container,
.video-preview-container {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/spotCheck/spotCheckEmail.vue